// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1413f283","239":"0ac4b1b0","453":"a7e2e667","455":"a4da0446"}[chunkId] + ".chunk.js";
};